var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"separator-container",attrs:{"id":_vm.id}},[_c('div',{staticClass:"separator valign-wrapper"},[_c('h4',[_vm._v(_vm._s(_vm.text))])])])}
var staticRenderFns = []

export { render, staticRenderFns }